import { Service } from "typedi";
import { ControllerOutboundMessage } from "../../shared/ChannelProtocol";
import { ContentScriptChannel } from "./ContentScriptChannel";
import { InstanceCoordinator } from "./InstanceCoordinator";

/**
 * Abstracts "send this message to every content script in the browser".
 *
 * On the leader: broadcasts via `InstanceCoordinator` AND writes directly to
 * the local `ContentScriptChannel` (since BroadcastChannel does not echo to
 * the sender).
 */
@Service()
export class ControllerBroadcaster {
    private contentScriptChannel: ContentScriptChannel | null = null;

    constructor(private readonly coordinator: InstanceCoordinator) {}

    setLocalChannel(channel: ContentScriptChannel | null): void {
        this.contentScriptChannel = channel;
    }

    broadcastToContentScripts(message: ControllerOutboundMessage): void {
        this.contentScriptChannel?.send(message);
        this.coordinator.broadcast({ kind: "broadcast-to-content-scripts", message });
    }

    sendToInstance(targetInstanceId: string, message: ControllerOutboundMessage): void {
        if (targetInstanceId === this.coordinator.instanceId) {
            this.contentScriptChannel?.send(message);
            return;
        }
        this.coordinator.broadcast({ kind: "to-content-script", targetInstanceId, message });
    }
}
